import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import React__default, { useMemo } from 'react';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import { useDropdownContext } from './96f486109d0d2850b21eef94a8c44cc3323a66fb525ca5574171063673f9afca.cfe-internal.js';
import DropdownSearch from './2112bc762d733d982c5e73a04d4dec070a3a23955464aafc5b39b49c376dd189.cfe-internal.js';
import styles from './92eaf70a5288baa390f98abe62f370ca7d0fa305958109435f118350410b09ae.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import { FLYOUT_POPPER_OFFSET } from '../../utils/f5e4d8f62716db08736bdf8cd2bfb32640bfafeca586ef59cc354009b4870444.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import useScreenReaderAnnouncement from '../../hooks/useScreenReaderAnnouncement/512f506263b51a28e4f5625270af84bc8ecd591bd1100039f845b39b162a4827.cfe-internal.js';
import { useDidUpdate } from '../../hooks/useDidUpdate/f8ce5c85f293b5c4ca8be6bc5ac9f246003ac61cc91ab03b8814ccaab638a21a.cfe-internal.js';
import Popper from '../../utils/Popper/53f589867426c0fe9404d76ffe1e6e0db92964f6396b0b62988d89a525e5a08b.cfe-internal.js';
import { Flyout } from '../../utils/Flyout/09954034ec71aee5026d787e9a48147406abc7ea70b631954c27e40a9ea50559.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';

var _excluded = ["children", "placement", "onKeyDown", "portalTarget", "private_offset", "style", "aria-labelledby"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var DropdownList = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
    _onKeyDown = _ref.onKeyDown,
    portalTarget = _ref.portalTarget,
    _ref$private_offset = _ref.private_offset,
    offset = _ref$private_offset === void 0 ? FLYOUT_POPPER_OFFSET : _ref$private_offset,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    externalAriaLabelledBy = _ref['aria-labelledby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useDropdownContext = useDropdownContext(),
    isOpen = _useDropdownContext.isOpen,
    buttonRef = _useDropdownContext.buttonRef,
    buttonId = _useDropdownContext.buttonId,
    minWidth = _useDropdownContext.minWidth,
    listRef = _useDropdownContext.listRef,
    listId = _useDropdownContext.listId,
    onKeyDownList = _useDropdownContext.onKeyDownList,
    isMultiSelect = _useDropdownContext.isMultiSelect,
    isSearchable = _useDropdownContext.isSearchable,
    options = _useDropdownContext.options;
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var noMatchesText = useMemo(function () {
    return isSearchable && translate('noMatchesFound');
  }, [isSearchable, translate]);
  var ariaLabelledby = externalAriaLabelledBy !== null && externalAriaLabelledBy !== void 0 ? externalAriaLabelledBy : buttonId;
  var announceToScreenReader = useScreenReaderAnnouncement('assertive');
  var showNoResults = useMemo(function () {
    return _filterInstanceProperty(options).call(options, function (option) {
      return option.isVisible;
    }).length === 1;
  },
  // 1 to include the search box entry
  [options]);
  useDidUpdate(function () {
    if (showNoResults && isSearchable) {
      announceToScreenReader(noMatchesText);
    }
  }, [showNoResults, announceToScreenReader, noMatchesText, isSearchable]);
  return /*#__PURE__*/React__default.createElement(Popper, {
    open: true,
    isDisabled: !isOpen,
    placement: placement,
    anchorNode: buttonRef.current,
    portalTarget: portalTarget,
    modifiers: [{
      name: 'offset',
      options: {
        offset: offset
      }
    }],
    popper: /*#__PURE__*/React__default.createElement(Flyout, _extends({}, rest, {
      ref: mergeRefs(ref, listRef),
      anchorRef: buttonRef,
      id: listId,
      role: "listbox",
      "aria-multiselectable": isMultiSelect || undefined,
      "aria-labelledby": ariaLabelledby,
      hidden: !isOpen,
      onKeyDown: function onKeyDown(e) {
        _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(e);
        onKeyDownList(e);
      },
      style: _objectSpread({
        minWidth: minWidth
      }, style)
    }), isSearchable && /*#__PURE__*/React__default.createElement(DropdownSearch, null), children, isSearchable && showNoResults && /*#__PURE__*/React__default.createElement("div", {
      className: styles.emptyOption
      // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
      ,
      role: "option" // `aria-selected` is omitted because this option is not selectable
    }, noMatchesText))
  });
});
var DropdownList$1 = DropdownList;

export { DropdownList$1 as default };
